import { useLingui } from "@lingui/react/macro";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";
import { useAppForm } from "~/components/ui/form";
import { useTRPC } from "~/trpc/client";

export function useAuthLogoutForm() {
	const queryClient = useQueryClient();
	const trpc = useTRPC();
	const navigate = useNavigate();
	const { t } = useLingui();

	const authLogoutMutation = useMutation(
		trpc.auth.logout.mutationOptions({
			async onSuccess() {
				queryClient.clear();
				await navigate({ to: "/auth/login", replace: true });
				toast.success(t`You have been logged out successfully.`);
			},
		}),
	);

	return useAppForm({
		async onSubmit() {
			await authLogoutMutation.mutateAsync(undefined);
		},
	});
}
